import React from "react";
import { Tag } from "antd";
import { formatDate } from "../../utility/formatDate";

const ENROLLMENT_SOURCE_MAP = {
  INDIVIDUAL: "Individual Assignment",
  BUNDLE: "Bundle Assignment",
};

const STATUS_STYLE_MAP = {
  Completed:    { color: "#066710", background: "#EEFFF0", borderColor: "#95DE9D" },
  passed:    { color: "#066710", background: "#EEFFF0", borderColor: "#95DE9D" },
  "In Progress": { color: "#C77A00", background: "#FFF8C7", borderColor: "#FBDC94" },
  default: { color: "#C80000", background: "#FFEEEE", borderColor: "#FFAAAA" },
};


const formatPercentage = (val) => {
  const num = Number(val || 0);
  return `${num % 1 === 0 ? num : num.toFixed(2)}%`;
};

const renderStatusTag = (status) => {
  const { color, background, borderColor } =
    STATUS_STYLE_MAP[status] || STATUS_STYLE_MAP.default;

  return (
    <Tag
      style={{
        padding: "10px 16px",
        borderRadius: "10px",
        border: "1px solid",
        color,
        fontWeight: "500",
        borderColor,
        backgroundColor: background,
      }}
    >
      {status}
    </Tag>
  );
};

export const commonColumns = [
  {
    title: "Name",
    dataIndex: "displayTitle",
    width: 200,
    render: (_, record) => (
      <>
        <strong>{record.displayTitle}</strong>
        <div style={{ fontSize: "12px", color: "#888" }}>
          Enrollment: {ENROLLMENT_SOURCE_MAP[record.enrollmentSource] || record.enrollmentSource}
          {record.groupName && record.groupName !== "null" && record.enrolleeType === "USER" && (
            <div>Group: {record.groupName}</div>
          )}
          {record.bundleName && record.bundleName !== "null" && (
            <div>Bundle: {record.bundleName}</div>
          )}
        </div>
      </>
    ),
  },
  {
    title: "Type",
    dataIndex: "enrolleeType",
    render: (val) => (val === "USER" ? "User" : "Group"),
    width: 150,
  },
  {
    title: "Enrolled At",
    dataIndex: "enrolledAt",
    render: (date) => formatDate(date, "DD-MMM-YYYY"),

  },
  {
    title: "Deadline",
    dataIndex: "deadline",
    render: (date) => formatDate(date, "DD-MMM-YYYY"),

  },
  {
    title: "Progress",
    dataIndex: "courseCompletionPercentage",
    render: formatPercentage,

  },
  {
    title: "Status",
    dataIndex: "status",
    render: renderStatusTag,
  },
  {
    title: "Adherence",
    dataIndex: "adherence",
    width: 120
  },
];

export const courseSingleColumns = [
  {
    title: "Name",
    dataIndex: "displayTitle",
    width: 200,
    render: (_, record) => (
      <>
        <strong>{record.displayTitle}</strong>
        <div style={{ fontSize: "12px", color: "#888" }}>
          Enrollment: {ENROLLMENT_SOURCE_MAP[record.enrollmentSource] || record.enrollmentSource}
          {record.groupName && record.groupName !== "null" && record.enrolleeType === "USER" && (
            <div>Group: {record.groupName}</div>
          )}
          {record.bundleName && record.bundleName !== "null" && (
            <div>Bundle: {record.bundleName}</div>
          )}
        </div>
      </>
    ),
  },
  {
    title: "Type",
    dataIndex: "enrolleeType",
    render: (val) => (val === "USER" ? "User" : "Group"),
    width: 150,
  },
  {
    title: "Progress",
    dataIndex: "courseCompletionPercentage",
    render: formatPercentage,
    width: 150,

  },
  {
    title: "Status",
    dataIndex: "status",
    render: renderStatusTag,
    width:150,
  },
  {
    title: "Quiz",
    dataIndex: "quizResult",
    render: renderStatusTag,
    width:150
  },
  {
    title: "Adherence",
    dataIndex: "adherence",
    width: 120
  },

];